import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { RootState } from 'app/store'
import Axios from 'constants/functions/Axios'
import { initialState } from './constant'

export const getListAnnouncement = createAsyncThunk(
  'announcement/list',
  async ({ query }: { query?: URLSearchParams }) => {
    const response = await Axios({
      method: 'GET',
      url: '/function/banner',
      params: query
    })
    return response?.data
  }
)

export const getAnnouncement = createAsyncThunk(
  'announcement/detail',
  async ({id, query, fields}: { id: string, query?: URLSearchParams, fields: Array<string> }) => {
    const response = await Axios({
      method: 'GET',
      url: `/function/banner/detail/${id}`,
      params: query
    })
    let data = {}
    fields.forEach((field) => {
      data[field] = response?.data?.data?.[field]
    })

    return { ...response?.data, data }
  }
)

export const announcementSlice = createSlice({
  name: 'announcement',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // List announcement
      .addCase(getListAnnouncement.pending, (state) => {
        state.list.status = 'LOADING'
      })
      .addCase(getListAnnouncement.rejected, (state) => {
        state.list.status = 'FAILED'
      })
      .addCase(getListAnnouncement.fulfilled, (state, action) => {
        state.list.status = 'SUCCESS'
        state.list.data = action.payload.data
        state.list.count = action.payload.length
      })

      // Detail announcement
      .addCase(getAnnouncement.pending, (state) => {
        state.detail.status = 'LOADING'
      })
      .addCase(getAnnouncement.rejected, (state) => {
        state.detail.status = 'FAILED'
      })
      .addCase(getAnnouncement.fulfilled, (state, action) => {
        state.detail.status = 'SUCCESS'
        state.detail.data = action.payload.data
      })
  },
})

export const selectAnnouncement = (state: RootState) => state.announcement.detail
export const selectListAnnouncement = (state: RootState) => state.announcement.list

export default announcementSlice.reducer
